module.exports = __webpack_public_path__ + "onboarding-feed-docker.49aac5634d8fa14fb3bd4f46e0897e35.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/library/empty/onboarding-feed-docker.svg
// module id = 4983871868781371
// module chunks = 1